import { api } from '@bilibili-maoer/web-utils';

var FEEDBACK_URL = "".concat(api.MISSEVAN_SITE_MAIN, "/mfeedback/sobot");
var DOC_DUTY_URL = "".concat(api.MISSEVAN_LINK_PREFIX_URL, "/rule/duty");
var DOC_PRIVACY_URL = "".concat(api.MISSEVAN_LINK_PREFIX_URL, "/rule/privacy");
var DEFAULT_REGION = {
  code: 'CN',
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  value: 86,
  name: '中国大陆'
};

export { DEFAULT_REGION, DOC_DUTY_URL, DOC_PRIVACY_URL, FEEDBACK_URL };
